import React from 'react';
import { ShieldCheck, Star, Leaf, ThumbsUp } from 'lucide-react';
export function TrustBar() {
  const badges = [{
    icon: ShieldCheck,
    text: 'Licensed & Insured'
  }, {
    icon: Star,
    text: '5-Star Rated'
  }, {
    icon: Leaf,
    text: 'Eco-Friendly Solutions'
  }, {
    icon: ThumbsUp,
    text: 'Satisfaction Guaranteed'
  }];
  return <div className="bg-navy text-white py-6" data-id="element-206" data-mp="1qx4wodw04awb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207" data-mp="1qvaayxcwoer6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-208" data-mp="1uxymjct07zru">
          {badges.map((badge, index) => {
          const Icon = badge.icon;
          return <div key={index} className="flex flex-col items-center justify-center space-y-2" data-id="element-209" data-mp="1lxs9fs17x1t7" data-mpi={index}>
                <Icon className="w-8 h-8 text-light-blue" data-id="element-210" data-mp="5iqpvo7ajhcm" />
                <span className="font-montserrat font-semibold text-sm md:text-base" data-id="element-211" data-mp="ajer12p8hekk">
                  {badge.text}
                </span>
              </div>;
        })}
        </div>
      </div>
    </div>;
}